/**
 * @Author: Zewei
 * @Date:   2018-01-23T19:25:15+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-26T14:58:27+08:00
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchUserList, fetchUserInit, createNewUser, deleteUsers,handleAuthorize,
         inactiveUsers, fetchUserDetail, hiddenEditUserModal, updateUserDetail, resetUsersPassword } from '../../actions/system-setting-actions.js';
import { fetchDepartmentsList } from '../../actions/department-structure-actions.js';
 import { fetchEmployeesUserList } from '../../actions/employee-management-actions.js';
import { Table, Divider, Button, Modal, Spin, message, Input, TreeSelect } from 'antd';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import UserModal from '../../components/SystemSetting/UserModal.js';
import './style.less';


const { Search } = Input;
// const { Option } = Select;
const { TreeNode } = TreeSelect;

 const mapStateToProps = state => ({
   systemSetting: state.systemSetting,
   departmentStructure: state.departmentStructure,
    employeeManagement: state.employeeManagement
 });
 const mapDispatchToProps = { fetchUserList, fetchUserInit, createNewUser, deleteUsers,handleAuthorize,fetchEmployeesUserList,
                              inactiveUsers, fetchUserDetail, hiddenEditUserModal, updateUserDetail, resetUsersPassword,
                              fetchDepartmentsList };

 @connect(mapStateToProps, mapDispatchToProps)
 class UserManagement extends Component {
     state = {
       modalVisible: false,
       resetPwdModalVisibal: false,
       selectedRowKeys: [], // Check here to configure the default column
       username: '',
     }

     componentDidMount() {
         this._fetchUserList()
         this._fetchUserInit()
         this._fetchDepartmentsList()
         // this._fetchEmployeesUserList()
     }

     _fetchUserList = (params) => {
         let { staffParams, departmentParams } = this.state;
         params = {...staffParams, ...departmentParams, ...params};
         // console.log(params)
         this.props.fetchUserList(params)
     }
     _fetchUserInit = () => {
         this.props.fetchUserInit()
     }
     _fetchDepartmentsList = () => {
         this.props.fetchDepartmentsList()
     }
     _fetchEmployeesUserList = () => {
          this.props.fetchEmployeesUserList()
    }

     handleAddNew = () => {
       this.setState({
         modalVisible: true,
       });
     }

     handleReset = () => {
         // 重置所有查询条件
         this.setState({
             staffParams: {},
             departmentParams: {},
             value: "",
             employeeValue: ""
         })
         // 因为 setState 是异步 所以下面 直接调用了 来自上层组件的 dispatch 而没有选择调用 this._fetchUserList
         this.props.fetchUserList()
     }

     handleDelete = () => {
      let { selectedRowKeys } = this.state;
      if (selectedRowKeys.length > 0) {
        Modal.confirm({
          title: '确定删除?',
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
            let params = {ids: selectedRowKeys};
            this.props.deleteUsers(params);
          },
          onCancel: () => {}
        });
      } else {
        message.warning('请选择用户');
      }
     }
      handleAuthorize = () => {
      let { selectedRowKeys } = this.state;
      if (selectedRowKeys.length > 0) {
        Modal.confirm({
          title: '确定授权?',
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
            let params = {ids: selectedRowKeys};
            // console.log(params);
            this.props.handleAuthorize(params);
          },
          onCancel: () => {}
        });
      } else {
        message.warning('请选择用户');
      }
     }
     handleInactiveUser = () => {
      let { selectedRowKeys } = this.state;
      if (selectedRowKeys.length > 0) {
        Modal.confirm({
          title: '确定冻结?',
          okText: '确认',
          cancelText: '取消',
          onOk: () => {
            let params = {ids: selectedRowKeys};
            this.props.inactiveUsers(params);
          },
          onCancel: () => {}
        });
      } else {
        message.warning('请选择用户');
      }
     }

     handleResetPassword = () => {
         let { selectedRowKeys } = this.state;
         if (selectedRowKeys.length > 0) {
             this.setState({
                 resetPwdModalVisibal: true
             })
         } else {
             message.warning('请选择用户');
         }
     }
     hideResetPswdModal = () => {
         this.setState({
             resetPwdModalVisibal: false
         })
     }

     handleResetPwdInputChange = (param, e) => {
         e.preventDefault()
         e.stopPropagation()
         this.setState({
             [param]: e.target.value
         })
     }
     handleCfmPwdReset = () => {
         let {resetPwd, cfmResetPwd, selectedRowKeys } = this.state;
         if (resetPwd === cfmResetPwd) {
             let payload = {
                 ids: selectedRowKeys,
                 password: resetPwd
             }
             this.props.resetUsersPassword(payload)
             this.hideResetPswdModal()
         } else {
             message.error('密码两次输入不一致')
         }
     }

     handleEditUser = (record) => {
      this.props.fetchUserDetail({'modelId': record.id})
     }

     handleUpdateUser = (value) => {
      this.props.updateUserDetail(value, res => {
          if (res) {
            this.props.hiddenEditUserModal();
          }
        });
      //   let state = this.state,
      //       { userDetail } = this.props.systemSetting,
      //       payload = {
      //         'id': userDetail.id,
      //         'user_name': state['user_name'] ? state['user_name'] : userDetail['user_name'],
      //         'code': state['code'] ? Number(state['code']) : userDetail['code'],
      //         'password': state['password'] ? state['password'] : '',
      //         'birthday': state['birthday'] ? state['birthday'] : userDetail['birthday'],
      //         'phone': state['phone'] ? state['phone'] : userDetail['phone'],
      //         'email': state['email'] ? state['email'] : userDetail['email'],
      //         'role_id': state['role_id'] ? Number(state['role_id']) : userDetail['role_id'],
      //         'department_id': state['department_id'] ? Number(state['department_id']) : userDetail['department_id'],
      //       }
      // 　　var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
      // 　　if(payload.email === ""){
      //       message.error("邮件不能为空", 4)
      // 　　　　return false;
      // 　　}else if(!reg.test(payload.email)){
      //       message.error("邮件格式不正确", 4)
      // 　　　　return false;
      // 　　}
      //     var myreg=/^[1][0-9]{10}$/;  
      //     if(payload.phone === ""){
      //       message.error("手机号不能为空", 4)
      // 　　　　return false;
      //     }else if (!myreg.test(payload.phone)) {
      //       message.error("手机号格式不正确", 4)
      //       return false;
      //     }

      //   this.props.updateUserDetail(payload, res => {
      //     if (res) {
      //       this.props.hiddenEditUserModal();
      //     }
      //   });
     }

     handleCreateNewUser = (value) => {
      this.props.createNewUser(value, res => {
        if (res) {
          this.handleCancel()
        }
       })
      
      // console.log("---------------------createuser------------------------");
       // let state = this.state,
       //     code = Number(state['code']),
       //     user_name = state['user_name'],
       //     password = state['password'],
       //     birthday = state['birthday'],
       //     phone = state['phone'],
       //     email = state['email'],
       //     role_id = Number(state['role_id']),
       //     department_id = Number(state['department_id']);
 // console.log("code - " + code);
 // console.log("user_name - " + user_name);
 // console.log("password - " + password);
 // console.log("phone - " + phone);
 // console.log("email - " + email);
 // console.log("role_id - " + role_id);
 // console.log("department_id - " + department_id);
 //       if (code && user_name && password && phone && email && role_id && department_id) {
 // // console.log("---------------------createuser6767676767------------------------");
 //           let payload = {
 //               code,
 //               user_name,
 //               password,
 //               birthday,
 //               phone,
 //               email,
 //               role_id,
 //               department_id,
 //               status: 1,
 //               // function: this.state.function,
 //               // pid: 1,
 //               // organization_id: 1,
 //               // parent_id: 1,
 //               // sequence: 1,
 //               // Permissions: this.state.Permissions
 //           }
 //      　　var reg = new RegExp("^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$");
 //      　　if(payload.email === ""){
 //            message.error("邮件不能为空", 4)
 //      　　　　return false;
 //      　　}else if(!reg.test(payload.email)){
 //            message.error("邮件格式不正确", 4)
 //      　　　　return false;
 //      　　}
 //          var myreg=/^[1][0-9]{10}$/;  
 //          if(payload.phone === ""){
 //            message.error("手机号不能为空", 4)
 //      　　　　return false;
 //          }else if (!myreg.test(payload.phone)) {
 //            message.error("手机号格式不正确", 4)
 //            return false;
 //          }
 //           this.props.createNewUser(payload, res => {
 //            if (res) {
 //              this.handleCancel()
 //            }
 //           })
 //       } else {
 //           return
 //       }
     }

     handleCancel = (e) => {
       this.setState({
         modalVisible: false,
       });
     }
     handleCancelEditUserModal = () => {
        this.props.hiddenEditUserModal();
     }

     onSelectChange = (selectedRowKeys, selectedRows) => {
         this.setState({ selectedRowKeys });
     }

     handleInputChange = (param, e) => {
       e.preventDefault();
       e.stopPropagation();
       this.setState({
         [param]: e.target.value
       })
     }

     // param 为bind时传入参数， val 为 所选option的 key值
     handleSelectChange = (param, val) => {
       this.setState({
         [param]: val
       })
     }

     onDatePickerChange = (date, dateString) => {
         this.setState({
             birthday: dateString
         })
     }

     handleStaffCodeSearch = (value) => {
         let params = {
             user_name: value,
             code: value,
             phone: value,
             email: value
         }
         this.setState({staffParams: params,employeeValue: value})
         this._fetchUserList(params)
     }
     handleCodeSearch = (v) =>{
      console.log(v);
      if(v.length >= 3){
          let params = {job_number: v};
          this.props.fetchEmployeesUserList(params)
      }
     }
     handleCodeChange = (v) => {
        if(v){
          let param = {
              job_number: v
          }
          this.props.fetchEmployeesUserList(param);
        }
          
      }
     handleDepartmentSelectChange = (value) => {
         this.setState({ value });
         let params = {
             department_id: value
         }
         this.setState({departmentParams: params})
         this._fetchUserList(params)
     }

     componentWillReceiveProps(nextProps) {
         let { systemSetting } = nextProps;
         systemSetting.actionStatus && this._fetchUserList();
     }

     renderTreeNodes = (data) => {
       return data.map((item) => {
         if (item.children) {
           return (
             <TreeNode value={`${item.id}`} title={item.name} key={item.id} dataRef={item}>
               { item.children.length !== 0 &&this.renderTreeNodes(item.children) }
             </TreeNode>
           );
         }
         return <TreeNode {...item} />;
       });
     }
     setEmployeeValue =(event)=>{
        this.setState({employeeValue: event.target.value})
     }

    
     render() {
         const { userList, initUser, userDetail, userEditModalVisible } = this.props.systemSetting;
         const { employeeUserList } = this.props.employeeManagement
         const { departmentsList } = this.props.departmentStructure;
         const { selectedRowKeys, modalVisible, resetPwdModalVisibal } = this.state;
         const rowSelection = {
           selectedRowKeys,
           onChange: this.onSelectChange,
         };
         const columns = [{
             title: '工号',
             dataIndex: 'code',
             key: 'code'
           }, {
             title: '用户名',
             dataIndex: 'user_name',
             key: 'user_name',
             render: (text, record) => {
              if (record.status === 0) {
                return text + "(已冻结)";
              }
              return text
             }
           }, {
             title: '部门',
             dataIndex: 'department_name',
             key: 'departmentName',
           }, {
             title: '生日',
             dataIndex: 'birthday',
             key: 'birthday',
           }, {
             title: '联系方式',
             dataIndex: 'phone',
             key: 'phone',
           }, {
             title: '角色',
             dataIndex: 'role_name',
             key: 'roleName',
           }, {
             title: '操作',
             dataIndex: 'action',
             key: 'action',
             render: (text, record) => this.props.access.userManagement.u_value && 
               <span  onClick={this.handleEditUser.bind(this, record)}>
                  <Button icon="edit" size="small" className="row-action-btn">编辑</Button>
               </span>
             
           }];

           let paginationCfg;
           if (userList) {
               paginationCfg = {
                   current: userList.Page,
                   total: userList.Total,
                   pageSize: userList.PageSize,
                   onChange: (page) => {
                       this._fetchUserList({page})
                   }
               }
           }

         return (
             <section className="app-module-item">
                 <div className="colAction">
                     {this.props.access.userManagement.c_value && <Button type="primary" onClick={this.handleAddNew} style={{marginRight: "10px"}}>新增</Button>}

                     {this.props.access.userManagement.d_value && <Button type="primary" onClick={this.handleDelete} style={{marginRight: "10px"}}>删除</Button>}

  					         {this.props.access.userManagement.inactive_value && <Button type="primary" onClick={this.handleInactiveUser} style={{marginRight: "10px"}}>冻结</Button>}

                     {this.props.access.userManagement.password_value && <Button type="primary" onClick={this.handleResetPassword} style={{marginRight: "10px"}}>重置密码</Button>}

                     {this.props.access.userManagement.active_value && <Button type="primary" onClick={this.handleAuthorize} style={{marginRight: "10px"}}>授权</Button>}

                     <Search
                          placeholder="根据员工信息查询"
                          onSearch={this.handleStaffCodeSearch}
                          style={{ width: 200 }}
                          enterButton
                          value={this.state.employeeValue}
                          onChange={this.setEmployeeValue}
                     />
  					         <Divider type="vertical" />
                     {
                         departmentsList ?
                             <TreeSelect
                                style={{ width: 230 }}
                                value={this.state.value}
                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                placeholder="根据部门选择"
                                allowClear
                                treeDefaultExpandAll
                                onChange={this.handleDepartmentSelectChange}
                            >
                                 { this.renderTreeNodes(departmentsList) }
                            </TreeSelect>
                            :
                            <Spin />
                     }

                     <Button type="primary" onClick={this.handleReset} style={{marginLeft: "10px"}}>重置</Button>
                 </div>
                 {
                   userList ?
                     <Table
                         rowSelection={rowSelection}
                         columns={columns}
                         dataSource={userList.Data}
                         rowKey={record => record.id}
                         pagination={paginationCfg}
                     />
                     :
                     <Spin className="spin-center" />
                 }
                 {/* 新增用户 Modal 弹窗 */}
                 {
                     initUser ?
                      <UserModal
                        title="新增用户"
                        initUser={initUser}
                        departmentsList={departmentsList}
                        employeeUserList={employeeUserList}
                        modalVisible={modalVisible}
                        handleCreateNewUser={this.handleCreateNewUser}
                        handleCancel={this.handleCancel}
                        handleCodeSearch={this.handleCodeSearch}
                        handleCodeChange={this.handleCodeChange}
                        handleInputChange={this.handleInputChange}
                        handleSelectChange={this.handleSelectChange}
                        onDatePickerChange={this.onDatePickerChange}
                        handleDepartmentSelectChange={this.handleDepartmentSelectChange}
                      />
                      :
                      ''
                }
                {/* 编辑当前用户 Modal 弹窗 */}
                {
                      initUser && userDetail ?
                      <UserModal
                        title="编辑用户"
                        initUser={initUser}
                        departmentsList={departmentsList}
                        employeeUserList={employeeUserList}
                        userDetail={userDetail}
                        userEditModalVisible={userEditModalVisible}
                        handleCancel={this.handleCancelEditUserModal}
                        handleCodeSearch={this.handleCodeSearch}
                        handleCodeChange={this.handleCodeChange}
                        handleInputChange={this.handleInputChange}
                        handleSelectChange={this.handleSelectChange}
                        onDatePickerChange={this.onDatePickerChange}
                        handleUpdateUser={this.handleUpdateUser}
                      />
                      :
                      ''
                }
                {/* 重置密码 Modal 弹窗 */}
                {
                    <Modal
                      title="重置密码"
                      visible={resetPwdModalVisibal}
                      // onOk={this.showResetPswdModal}
                      onCancel={this.hideResetPswdModal}
                      footer={[
                          <Button key="back" onClick={this.hideResetPswdModal}>返回</Button>,
                          <Button key="submit" type="primary" onClick={this.handleCfmPwdReset} disabled={false}>
                            确认更改
                          </Button>,
                        ]}
                      destroyOnClose={true}
                    >
                      <Input
                          required
                          type="password"
                          placeholder="密码"
                          style={{marginBottom: 10}}
                          onChange={this.handleResetPwdInputChange.bind(this, 'resetPwd')}
                      />
                      <Input
                          required
                          type="password"
                          placeholder="确认密码"
                          onChange={this.handleResetPwdInputChange.bind(this, 'cfmResetPwd')}
                      />
                    </Modal>
                }
             </section>
         )
     }
 }

UserManagement = LayoutWrapper(UserManagement)

export default UserManagement;



// WEBPACK FOOTER //
// ./src/routes/SystemSetting/UserManagement.js